import React from 'react';
import PropTypes from 'prop-types';
import { MarkTabs } from 'ThreeTerminal_mobile_dynamic';
import { LazyImg } from '@ifeng/ui_pc_lazyLoad';
import { getHouseRecommend } from '../../../../services/api';
import styles from './index.css';

class HouseRecommend extends React.PureComponent {
    static propTypes = {
        houseSourceId: PropTypes.number,
        houseRegionId: PropTypes.number,
        houseBulidId: PropTypes.number,
    };

    state = {
        feedListTotal: [],
        feedList: [],
        isMoreBtn: true,
        feedStyle: 0,
    };

    componentDidMount() {
        this.getHouseRecommendData();
    }

    getHouseRecommendData = async () => {
        // * 优先级：房源>小区>楼盘
        const { houseSourceId, houseRegionId, houseBulidId } = this.props;
        const dictId = houseRegionId || houseBulidId || 0;
        const roomId = houseSourceId || 0;

        if (!dictId && !roomId) {
            return false;
        }
        let type = 1;

        if (houseBulidId) {
            type = 1;
        } else if (houseRegionId) {
            type = 2;
        }

        try {
            const data = await getHouseRecommend(dictId, type, roomId);
            const result = (data && data.data) || {};
            const feedStyle = parseInt(result.recommendMark) || 0;
            let feedList = [];

            if (feedStyle === 1) {
                feedList = result.recommendDictList;
            } else if (feedStyle === 2) {
                feedList = result.recommendRoomList;
            }

            if (!feedList || feedList.length === 0) return false;
            const feedListTotalData = feedList.slice(0, 10).map(item => ({
                url: item.href || '',
                imgSrc: item.coverImage || item.coverImgPath || 'https://x0.ifengimg.com/cmpp/2019/1014/imgload.png',
                title: item.dictName || item.sourceTitle || '',
                address: item.address || '',
                price: item.price || '价格待定',
                priceUnit: item.priceUnit || '',
                saleStatus: item.saleStatus || '',
                specialList: item.specialList || item.houseTagsList || [],
                bedroom: (item.bedroom && `${item.bedroom}室`) || '',
                livingroom: (item.livingroom && `${item.bedroom}厅`) || '',
                buildArea: item.buildArea || '',
                totalPrice: item.totalPrice || '',
                totalPriceUnit: item.totalPriceUnit || '',
                orientation: item.orientation,
            }));

            this.setState({
                feedListTotal: feedListTotalData,
                feedList: feedListTotalData.slice(0, 5),
                feedStyle,
            });
        } catch (error) {
            console.log(`${error}获取好房推荐接口失败`);
        }
    };

    moreData = () => {
        const { feedListTotal } = this.state;

        this.setState({
            feedList: feedListTotal.slice(0, 10),
            isMoreBtn: false,
        });
    };

    houseBuildFeedList = () => {
        const { feedList } = this.state;

        return feedList.map((item, index) => (
            <a href={item.url} key={index} className={styles.floorIntro}>
                {}
                <LazyImg
                    className={styles.floorIntroImg}
                    src={item.imgSrc}
                    placeholder="https://x0.ifengimg.com/cmpp/2019/1016/0d8cd6dd7c9a2c9size1_w226_h150.png"
                />
                <div className={styles.floorIntroText}>
                    <h2 className={styles.floorIntroTitle}>{item.title}</h2>
                    <div className={styles.floorIntroInfo}>{item.address}</div>
                    <div className={styles.floorIntroBox}>
                        <div className={styles.floorIntroPrice}>
                            <span className={styles.floorIntroNum}>{item.price}</span>
                            {item.priceUnit}
                        </div>
                    </div>
                    <div className={styles.floorIntroStatus}>
                        {item.saleStatus === '在售' && <span className={styles.floorIntroLive} />}
                        {item.saleStatus === '待售' && <span className={styles.floorIntroForsale} />}
                        {item.saleStatus === '售罄' && <span className={styles.floorIntroOut} />}
                        {item.specialList.slice(0, 3).map((items, indexs) => (
                            <span key={indexs} className={styles.floorIntroMark}>
                                {items}
                            </span>
                        ))}
                    </div>
                </div>
            </a>
        ));
    };

    houseSourceFeedList = () => {
        const { feedList } = this.state;

        return feedList.map((item, index) => (
            <a href={item.url} key={index} className={styles.floorIntro}>
                <LazyImg
                    className={styles.floorIntroImg}
                    src={item.imgSrc}
                    placeholder="https://x0.ifengimg.com/cmpp/2019/1016/0d8cd6dd7c9a2c9size1_w226_h150.png"
                />
                <div className={styles.floorIntroText}>
                    <h2 className={styles.floorIntroTitle}>{item.title}</h2>
                    <div className={styles.floorIntroInfo}>
                        <span className={styles.floorIntroSpace}>{item.bedroom + item.livingroom}</span>
                        <span className={styles.floorIntroSpace}>{item.buildArea}㎡</span>
                    </div>
                    <div className={styles.floorIntroBox}>
                        <div className={styles.floorIntroPrice}>
                            <span className={styles.floorIntroNum}>{item.totalPrice}</span>
                            {item.totalPriceUnit}
                        </div>
                        {item.orientation && <span className={styles.floorIntroSpace}>{item.orientation}</span>}
                        {item.address && <span className={styles.floorIntroSpace}>{item.address}</span>}
                    </div>
                    <div className={styles.floorIntroStatus}>
                        {item.specialList.slice(0, 3).map((items, indexs) => (
                            <span key={indexs} className={styles.floorIntroMark}>
                                {items}
                            </span>
                        ))}
                    </div>
                </div>
            </a>
        ));
    };

    render() {
        /**
         * 组件分发数据
         * 优先级：房源>小区>楼盘
         * type:1(楼盘数据)type:2(房源数据)
         */
        const { feedList, feedListTotal, isMoreBtn, feedStyle } = this.state;
        const markTabsObj = {
            title: '好房推荐',
        };

        return (
            feedList.length > 0 && (
                <section className={styles.floorRecommend}>
                    <MarkTabs content={markTabsObj} />
                    <section className={styles.floorRecommendBox}>
                        {feedStyle === 1 && this.houseBuildFeedList()}
                        {feedStyle === 2 && this.houseSourceFeedList()}
                        {feedListTotal.length > 5 &&
                            isMoreBtn && (
                                <div className={styles.floorMore}>
                                    <a
                                        href="javascript:void(0);"
                                        onClick={this.moreData}
                                        className={styles.floorMoreIcon}>
                                        查看更多
                                    </a>
                                </div>
                            )}
                    </section>
                </section>
            )
        );
    }
}

export default HouseRecommend;
